import DarpaLogo from "../../assets/logos/darpa-logo.png";
import NasaLogo from "../../assets/logos/nasa-logo.png";
import NiacLogo from "../../assets/logos/niac-logo.png";
import SpaceForceLogo from "../../assets/logos/space-force-logo.png";
import AfrlLogo from "../../assets/logos/afrl-logo.png";
import YCLogo from "../../assets/logos/YC-logo-black.png";
import TeamTable from "../../assets/company/team/teamTable.png";
import FacilitiesWide from "../../assets/company/facilities/facilitiesWide.png";
import PatentDrawing from "../../assets/company/history/patentDrawing.png";

// Product images
import TKOHero from "../../assets/products/TKO/tkoGlamourShot.jpg";
import TheiaHero from "../../assets/products/theia/Orion_with_satellites.jpg";
import CaptureBagHero from "../../assets/products/capture-bag/cb_iss.png";
import DaqastraHero from "../../assets/daqastra/summary/daqastra.png";

const logos = [
  { image: NasaLogo, url: "https://www.nasa.gov/", alt: "NASA" },
  { image: NiacLogo, url: "https://www.nasa.gov/about-niac/", alt: "NASA NIAC" },
  { image: SpaceForceLogo, url: "https://www.spaceforce.mil/", alt: "Space Force" },
  { image: DarpaLogo, url: "https://www.darpa.mil/about/offices/commercial-strategy", alt: "DARPA" },
  { image: AfrlLogo, url: "https://www.afrl.af.mil/", alt: "AFRL" },
  { image: YCLogo, url: "https://www.ycombinator.com/", alt: "Y Combinator" },
];

export const CapabilitiesData = [
  {
    id: 0,
    action: "Detect",
    title: "Sutter™ Technology",
    text: "Our innovative Sutter technology —named after Sutter's Mill in California where gold was discovered in 1848— enables low-cost telescopes and in-space sensors to detect asteroids and other dark, fast-moving objects in space.",
    linkID: "detecting",
    linkPath: "/capabilities",
  },
  {
    id: 1,
    action: "Capture",
    title: "Capture Bag™",
    text: "Capture Bag, a lightweight, durable, inflatable structure, will help clear Earth's orbits of dangerous debris and secure asteroids for mining.",
    linkID: "capturing",
    linkPath: "/capabilities",
  },
  {
    id: 2,
    action: "Move",
    title: "Worker Bee™ Powered by Omnivore™",
    text: "Our patented Omnivore propulsion system can utilize almost any volatile liquid, such as water, as a propellant, ensuring efficient spacecraft movement across vast distances in space.",
    linkID: "moving",
    linkPath: "/rnd",
  },
  {
    id: 3,
    action: "Process",
    title: "Optical Mining™",
    text: "Optical Mining harnesses the Sun's power to extract resources, including water and precious metals, from asteroids. These methods will also play a key role in recycling orbital debris and promoting cleaner recycling processes on Earth. ",
    linkID: "processing",
    linkPath: "/rnd",
  },
];

export const QuoteData = [
  {
    title: "World-Class Team",
    textContent: [
      "4 PhDs (Caltech, MIT) leading a team of 25",
      "Senior management with decades of experience building successful organizations",
    ],
    backgroundImage: TeamTable,
  },
  {
    title: "State-of-the-Art Facilities",
    textContent: [
      "7,000-ft² lab",
      "Capture Bag™ test bed",
      "Two large vacuum systems",
      "Optics lab",
    ],
    backgroundImage: FacilitiesWide,
  },
  {
    title: "First-in-Class IP Portfolio",
    textContent: [
      "22 issued patents",
      "Patents cover Detect, Capture, Move, and Process",
      "~10 additional patents pending",
    ],
    backgroundImage: PatentDrawing,
  },
  {
    title: "Key Partners",
    textContent: [],
    hrefs: logos,
  },
];

export const ProductCardsData = [
  {
    title: "Sutter TKO™",
    description: "Modular, rapidly deployable sky survey system for space domain awareness in MEO, GEO, and beyond",
    image: TKOHero,
    link: "/products/tko",
  },
  {
    title: "Theia",
    description: "100× more sensitive detection algorithm for faint moving objects in space, proven in real-world operations",
    image: TheiaHero,
    link: "/products/theia",
  },
  {
    title: "Capture Bag",
    description: "Lightweight, durable inflatable structure for orbital debris cleanup and object capture, demonstrated on orbit",
    image: CaptureBagHero,
    link: "/products/capturebag",
  },
  {
    title: "DAQAstra",
    description: "No-code data acquisition system proven from labs to the ISS, with plug-and-play simplicity",
    image: DaqastraHero,
    link: "/products/daqastra",
  },
];
